module.exports = "/_next/static/images/be375971b699ce1a2b3df0b9f9922ce3-credit-card-limit@0.75x.png.webp";